import * as React from "react";
import { useNavigate } from "react-router-dom";
const EdModal = (props) => {
    // const [show, setShow] = React.useState<boolean>(false);
    const navigate = useNavigate();
    const ref = React.useRef(null);
    React.useEffect(() => {
        const body = document.querySelector("body");
        body.style.overflow = props.show ? "hidden" : "auto";
        return () => {
            body.style.overflow = "auto";
        };
    }, [props.show]);
    React.useEffect(() => {
        if (!props.DisableOutsideClickClose) {
            let handleClickOutside = (event) => {
                if (ref.current &&
                    !ref.current.contains(event.target) &&
                    event.view.innerWidth - 17 >= event.clientX) {
                    props.setShow(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [ref]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `modal-backdrop ${props.show ? "show" : "fade"}` }),
        React.createElement("div", { className: `modal ${props.modalTitle} ${props.show ? "show" : "fade"}` },
            React.createElement("div", { className: `modal-dialog ${props.size}` },
                React.createElement("div", { className: "modal-content", ref: ref },
                    React.createElement("div", { className: `modal-header align-items-center justify-content-between` },
                        React.createElement("div", { className: `d-flex justify-conent-between align-items-center ${props.iconClass && props.iconClass}` },
                            props.icon && (React.createElement("i", { className: props.icon, onClick: () => props.iconOnClick() }, props.paths && props.paths)),
                            props.title && (React.createElement("h5", { className: "modal-title" }, props.hasOwnProperty("title") ? props.title : ""))),
                        !props.hideCrossBtn && (React.createElement("button", { type: "button", className: props.ownCloseIcon
                                ? props.ownCloseIcon
                                : "edel-icon-bold-close", onClick: () => {
                                !props.onCloseGoBack && props.setShow(false);
                                setTimeout(() => {
                                    (props === null || props === void 0 ? void 0 : props.closeDropdown) && (props === null || props === void 0 ? void 0 : props.closeDropdown(false));
                                }, 0);
                                (props === null || props === void 0 ? void 0 : props.onCloseGoBack) && (props === null || props === void 0 ? void 0 : props.onCloseGoBackFunction());
                            } },
                            React.createElement("i", { className: "" })))),
                    React.createElement("div", { className: `modal-body ${props.modalbodyClass}` }, props.children),
                    props.showFooter && (React.createElement("div", { className: "modal-footer" },
                        React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: () => {
                                props.setShow(false);
                                props.closeDropdown &&
                                    setTimeout(() => {
                                        props.closeDropdown(false);
                                    }, 0);
                            } }, "Close"),
                        React.createElement("button", { type: "button", className: "btn btn-primary" }, "Save changes"))))))));
};
export default EdModal;
